module.exports = __webpack_public_path__ + "img/beard-3.5c885c49.svg";